import React, { Component } from "react";
import { read, utils, writeFile } from 'xlsx';
import {
    CButton, CCol, CRow,
    CTooltip,
} from "@coreui/react";
import CIcon from '@coreui/icons-react';
import { helps } from "src/_helpers";
import configs from 'src/appConfigs';

export default class EmployeesExport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [] /* Array of Arrays e.g. [["a","b"],[1,2]] */,
            cols: [] /* Array of column objects e.g. { name: "C", K: 2 } */,
        };
        this.handleExport = this.handleExport.bind(this);
    }

    componentDidMount() {
        var data = [];
        const { employees } = this.props;
        if (!helps.isEmpty(employees)) {
            employees.map((employee, i) => {
                var birthdate = '';
                if (employee.birthdate) {
                    birthdate = employee.birthdate.toLocaleDateString();
                }
                var id_issuance_date = '';
                if (!helps.isEmpty(this.state.id_issuance_date) && typeof employee.id_issuance_date === 'object') {
                    id_issuance_date = employee.id_issuance_date.toLocaleDateString();
                } else {
                    id_issuance_date = new Date(employee.id_issuance_date).toLocaleDateString();
                }
                var item = [];
                item[0] = employee.employee_id;
                item[1] = employee.fullname;
                item[2] = configs.departments[employee.department];
                item[3] = birthdate;
                item[4] = configs.gens[employee.gen];
                item[5] = configs.positions[employee.position];
                item[6] = employee.id_number;
                item[7] = id_issuance_date;
                item[8] = "Cục CS QLHC về TTXH";
                item[9] = employee.bank_account_number;
                item[10] = employee.bank_name;
                item[11] = employee.permanent_address;
                item[12] = employee.phone;
                data.push(item);
            })
        }

        let _output = [];
        _output = _output.concat(data);
        //console.log(_output)
        this.setState({ data: _output });
    }

    make_cols = refstr => {
        let o = [], C = utils.decode_range(refstr).e.c + 1;
        for (var i = 0; i < C; ++i) o[i] = { name: utils.encode_col(i), key: i }
        return o;
    };

    handleExport() {
        /* convert state to workbook */
        const ws = utils.aoa_to_sheet(this.state.data);
        const wb = utils.book_new();
        let today = new Date();
        var name = today.getDate() + '-' + today.getMonth() + '-' + today.getFullYear() + '_' + Date.now();
        //console.log(name)
        utils.book_append_sheet(wb, ws, name);
        /* generate XLSX file and send to client */
        writeFile(wb, name + ".xlsx");
    }

    render() {
        return (
            <CRow>
                <CCol xl={12} md={12}>
                    <CTooltip content={'Export to Excel'}>
                        <CButton
                            color="info"
                            size="sm"
                            title="Export"
                            className="ml-1"
                            onClick={(e) => { this.handleExport(e) }}
                        >
                            <CIcon name="cil-save" className="mfe-1 mt-0"></CIcon>
                            Export
                        </CButton>
                    </CTooltip>
                </CCol>
            </CRow>
        );
    }
}